// react-native-geolocation-service for the web: the browser Geolocation API.
// The package's own web fallback rejects requestAuthorization, which breaks
// the iOS-style permission check, so resolve it the way a browser behaves:
// the permission popup appears on the first position read.
export const PositionError = Object.freeze({
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
  TIMEOUT: 3,
  PLAY_SERVICE_NOT_AVAILABLE: 4,
  SETTINGS_NOT_SATISFIED: 5,
  INTERNAL_ERROR: -1,
});

const unavailable = error =>
  error?.({
    code: PositionError.POSITION_UNAVAILABLE,
    message: 'Location is not available in this browser',
  });

const Geolocation = {
  setRNConfiguration() {},

  async requestAuthorization() {
    try {
      const res = await navigator.permissions?.query({name: 'geolocation'});
      if (res?.state === 'denied') {
        return 'denied';
      }
    } catch (e) {
      // Permissions API unsupported: let the position read ask.
    }
    return navigator.geolocation ? 'granted' : 'disabled';
  },

  getCurrentPosition(success, error, options) {
    if (!navigator.geolocation) {
      return unavailable(error);
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
  },

  watchPosition(success, error, options) {
    if (!navigator.geolocation) {
      return unavailable(error);
    }
    return navigator.geolocation.watchPosition(success, error, options);
  },

  clearWatch(id) {
    navigator.geolocation?.clearWatch(id);
  },

  stopObserving() {},
};

export default Geolocation;
